module.exports = __webpack_public_path__ + "img/qr_code 48px OLD.6572b503.svg";